import { Skeleton, SkeletonGroup } from '../common/Skeleton/Skeleton.jsx';

/**
 * The admin dashboard's Overview tab, shown while its first load is on
 * the way.
 *
 * The same frames as the real tab -- the .ov column, the eight .ov-tile
 * readouts (six figures and the two live presence tiles, online students
 * and online trainers), the .ov-duo pair of Recent batches / Recent
 * events, and the Recent jobs panel under them -- so the page does not
 * move when the data lands.
 */

const TILES = 8;
const ROWS = 5;

const Panel = () => (
  <section className="ov-panel">
    <header className="ov-panel-head">
      <Skeleton shape="title" width="40" />
    </header>
    <div className="lms-skel-stack">
      {Array.from({ length: ROWS }, (_, i) => (
        <div className="lms-skel-row" key={i}>
          <Skeleton shape="mark" />
          <div className="lms-skel-stack lms-skel-grow">
            <Skeleton width="55" />
            <Skeleton width="85" />
          </div>
          <Skeleton shape="pill" />
        </div>
      ))}
    </div>
  </section>
);

const AdminOverviewSkeleton = () => (
  <SkeletonGroup label="Loading the overview" className="ov">
    <div className="ov-tiles">
      {Array.from({ length: TILES }, (_, i) => (
        <div className="ov-tile" key={i}>
          <Skeleton width="70" />
          <Skeleton shape="figure" width="40" />
        </div>
      ))}
    </div>

    <div className="ov-duo">
      <Panel />
      <Panel />
    </div>

    <Panel />
  </SkeletonGroup>
);

export default AdminOverviewSkeleton;
